// extracted by mini-css-extract-plugin
export default {"btn-on-map":"BtnOnMap_btn-on-map__zYeme","btn-on-map-icon":"BtnOnMap_btn-on-map-icon__72BgI","btn-on-map-text":"BtnOnMap_btn-on-map-text__u+Sx3"};